import React from "react";
export const ShortNav = () => {
    return (React.createElement("nav", { className: "nav" },
        React.createElement("span", null,
            React.createElement("a", { href: "https://www.phoenixreisen.com" },
                React.createElement("i", { className: "fas fa-home" }),
                " Homepage")),
        React.createElement("span", null,
            React.createElement("a", { href: "https://www.phoenixreisen.com/magazin" },
                React.createElement("i", { className: "fas fa-book-open" }),
                " Magazin")),
        React.createElement("span", null,
            React.createElement("a", { href: "https://meinereise.phoenixreisen.com" },
                React.createElement("i", { className: "fas fa-sign-in-alt" }),
                " Mein Phoenix"))));
};
export default ShortNav;
